import { Card } from '@iheartjane/reefer';
import type { ReactNode } from 'react';
import { Children, Fragment } from 'react';

import { SpecialDetailStatusBundleProgress } from './specialDetailStatusBundleProgress/specialDetailStatusBundleProgress';
import { SpecialDetailStatusFooter } from './specialDetailStatusFooter/specialDetailStatusFooter';
import { SpecialDetailStatusHeader } from './specialDetailStatusHeader/specialDetailStatusHeader';
import { SpecialDetailStatusSticky } from './specialDetailStatusSticky/specialDetailStatusSticky';

const SpecialDetailStatusCard = ({ children }: { children: ReactNode }) => {
  const childrenArray = Children.toArray(children);

  return (
    <Card width="100%" height="100%" flat>
      {childrenArray.map((child, index) => (
        <Fragment key={index}>{child}</Fragment>
      ))}
    </Card>
  );
};

export const SpecialDetailStatus = Object.assign(SpecialDetailStatusCard, {
  Header: SpecialDetailStatusHeader,
  BundleProgress: SpecialDetailStatusBundleProgress,
  Footer: SpecialDetailStatusFooter,
  Sticky: SpecialDetailStatusSticky,
});
